import React, { useEffect, useState, useRef, Suspense, memo } from "react";
import { useObjectStore } from "../zustand/objects";
import { Accordion, Card, Button, Image, Text, Group, Badge, ActionIcon, Grid, Textarea, useMantineTheme } from '@mantine/core';
import SidebarCommentThread from "./SidebarCommentThread"
import { getComments } from '../api'
import DeleteIcon from '@mui/icons-material/Delete';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import SendIcon from '@mui/icons-material/Send';
import { useField } from '@mantine/form';

const CommentSidebar = () => {

  const { threads, currentObjectArtboard, addComment, deleteThread, loadThreads, viewedComments, viewedThread, setViewedComments, setViewedThread, scrubViewedComments } = useObjectStore()

  const [open, setOpen] = useState()
  const messagesEndRef = useRef(null); // Reference to the bottom of the scrollable div
  const sidebarRef = useRef(null); // Reference to the bottom of the scrollable div

  const handleOpenAccordion = (id) => {
    setOpen(true)
    setViewedThread(id)
    loadComments(id)

  }


  const handleDelete = (id) => {
    deleteThread(id)
    setTimeout(() => {
      loadThreads()
    }, "500");
  }


  const loadComments = (id) => {
    getComments(id)
      .then(res => setViewedComments(res))
  }

  const theme = useMantineTheme();


  return (
    <ul id='table' style={{ paddingLeft: 0, paddingBottom: 5, overflow: 'scroll', listStyle: "none", marginTop: "0px", marginBottom: "0px", overflowX: "hidden", overflowY: "auto" }}
      ref={sidebarRef}>
      <Accordion value={viewedThread} variant="contained" onChange={(e) => handleOpenAccordion(e)}
      >
        <Group justify="space-between">
          <Text fw={1000} size="xs" c="dimmed" mb="sm">
            SCENE COMMENTS</Text>
          <Badge size="sm" mb="sm" variant="light" color={'gray'}>{threads && threads[currentObjectArtboard] && threads[currentObjectArtboard].length ? threads[currentObjectArtboard].length : 0} COMMENTS</Badge></Group>
        {threads && threads[currentObjectArtboard] && threads[currentObjectArtboard].map((mapped, i) => {
          return (
            <Suspense key={mapped.id} fallback={null}>
              <li style={{ paddingTop: i >= 1 ? 8 : 0 }}>
                <Accordion.Item value={mapped.id} label="comments" variant="contained" onChange={() => handleOpenAccordion(mapped.id)}
                  style={{
                    borderWidth: 2,
                    borderColor: viewedThread === mapped.id ? theme.colors.primary[5] : theme.colors.secondary[3],
                    backgroundColor: viewedThread === mapped.id ? theme.colors.primary[0] : theme.colors.neutral[0],
                    boxShadow: viewedThread === mapped.id && '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)', // shadow-md
                  }}>
                  <Accordion.Control>
                    <Group gap={10}>
                      <QuestionAnswerOutlinedIcon htmlColor={viewedThread === mapped.id ? theme.colors.primary[5] : theme.colors.secondary[4]} />
                      <Text style={{ textOverflow: 'ellipsis', maxWidth: "180px", overflow: "hidden", whiteSpace: 'nowrap' }}
                        fw={viewedThread === mapped.id && 500}
                        size="sm">{new Date(mapped.last_updated).toLocaleDateString()}: {mapped.latest_comment.comment_content}</Text></Group>
                  </Accordion.Control>
                  <Accordion.Panel>
                    {viewedThread === mapped.id && viewedComments.map((mapped, i) => (
                      <UserComment key={mapped.id} id={mapped.id} threadId={mapped.id} userNameProp={mapped.author} commentDateProp={new Date(mapped.created_at).toLocaleDateString()} fullTextProp={mapped.comment_content} />
                    ))}
                    <div ref={messagesEndRef} />
                  </Accordion.Panel>
                </Accordion.Item></li></Suspense>)
        })}
      </Accordion></ul>)
}


export default CommentSidebar


const UserComment = ({ id, threadId, userNameProp, commentDateProp, fullTextProp }) => {


  const { threads, addComment, deleteComment, deleteThread, loadThreads, viewedComments, viewedThread, setViewedComments, setViewedThread, scrubViewedComments } = useObjectStore()


  const [hover, setHover] = useState(false)

  const handleDeleteComment = () => {
    deleteComment(threadId, id)
  }

  return (
    <Grid style={{
      paddingBottom: 0
    }}>
      <Grid.Col pb={0} span={6}><div style={{ paddingLeft: 10, paddingTop: 10, paddingBottom: 0 }}>
        <Text size="xs" fw={500}>{userNameProp}</Text></div></Grid.Col>
      <Grid.Col pb={0} span={6}><div style={{ paddingRight: 10, paddingTop: 10, paddingBottom: 0 }}>
        <Text size="xs">{commentDateProp}</Text></div></Grid.Col>
      {/* <Grid.Col pb={0} span={2}>
        <ActionIcon ml={5} w={30} h={40} variant="transparent" size={'xs'} onClick={() => handleDeleteComment()}
          onPointerOver={() => setHover(true)}
          onPointerLeave={() => setHover(false)}
          color={!hover ? "#424242" : "#868e96"} >
          <DeleteIcon fontSize='medium' /></ActionIcon></Grid.Col> */}
      <Grid.Col span={12} pt={0}><div style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 0 }}>
        <Text size="xs">{fullTextProp}</Text></div></Grid.Col>
    </Grid>
  )
}

const CommentSubmit = ({ id, loadComments, addComment }) => {
  const [hover1, setHover1] = useState(false)

  const { currentObjectArtboard, threads } = useObjectStore()

  const handleCommentSubmit = (val) => {
    addComment(id, val, currentObjectArtboard)
  }

  const field = useField({
    initialValue: '',
    validateOnBlur: true,
    validate: (value) => (value.trim().length < 1 ? 'Please enter a value' : handleCommentSubmit(value)),
  });

  return (
    <div
      style={{
        position: "sticky",
        bottom: 0,
        background: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "none",
        overflowX: "none"
      }}
    >
      <Textarea
        {...field.getInputProps()}
        placeholder="Leave a reply..."
        style={{
          border: "none",
          outline: "none",
          flex: 1, // Make the textarea take available space
          fontSize: "16px", // Larger placeholder text
          color: "#7c7c7c",
          paddingBottom: "10px", // Increased padding for vertical centering
          paddingLeft: "10px", // Increased padding for vertical centering
          paddingRight: "10px", // Increased padding for vertical centering
          lineHeight: "1.5", // Adjust line height for better vertical alignment
          overflow: "hidden", // Prevent overflow
        }}
      />

      {/* Send Icon */}
      <ActionIcon ml={5} w={30} h={40} variant="transparent" size={'xs'}
        onPointerOver={() => setHover1(true)}
        onPointerLeave={() => setHover1(false)}
        onClick={() => field.validate}
        color={!hover1 ? "#424242" : "#868e96"} >
        <SendIcon /></ActionIcon>
    </div>
  )
}
